import { Box, Typography } from "@mui/material";
import { useMemo, useState } from "react";
import { DownArrow, SettingsIcon, UpArrow } from "../../../utils/iconRefs/recipeStepsIcons";
import { HeatingModeEnum } from "../utils/constants";
import { getTime, isCurrentInstructionTAT, useCalculateTotalTime } from "../utils/getTime";
import { ClockIcon } from "../../../utils/iconRefs/recipePageIcons";
import { ReactComponent as MultipleSettingsIcon } from "../../../svg/multipleSettingsIcon.svg"
import { settingsInterface } from "../../../app/recipeCreation/createRecipe.types";
import Settings from "./settings";

const SettingsDisplay = ({
    settings,
}: {
    settings: Array<settingsInterface>;
}) => {
    const [expanded, setExpanded] = useState(false);
    const totalTime = useCalculateTotalTime(settings);
    const containsTATInstruction = useMemo(() => !!settings?.find((setting: settingsInterface) => [HeatingModeEnum.TAT, HeatingModeEnum.RICECOOKER].includes(setting.heatingMode)), [settings]);
    const firstTATIndex = settings?.findIndex((instruction: any) => isCurrentInstructionTAT(instruction));

    return (
        <Box sx={{ padding: '20px' }}>
            <Box>
                {
                    !expanded && <Box
                        sx={{
                            backgroundColor: 'transparent',
                            display: 'flex',
                            justifyContent: 'center',
                        }}
                        onClick={() => setExpanded(!expanded)}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                            <Box sx={{ display: 'flex', gap: '18px', alignItems: 'center' }}>
                                {settings.length > 1 ? <MultipleSettingsIcon /> : <SettingsIcon />}
                                <Box sx={{ border: '1px solid #989898', height: '28px' }} />
                                <Typography color='#8B8B8B' variant='body2paralell'>Tap to view instructions</Typography>
                            </Box>
                            <Box sx={{ p: 1 }} >
                                <DownArrow />
                            </Box>
                        </Box>
                    </Box>
                }
                <Box
                    sx={{ paddingBottom: '5px', px: 0, pt: 0, overflow: expanded ? 'visible' : 'hidden', height: expanded ? 'auto' : 0, transition: 'height 0.5s ease-out' }}
                >
                    <Box sx={{ display: 'flex', backgroundColor: '#fff', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Typography variant='body2paralell' textAlign='center' width='86px' color='#8B8B8B'>
                                Blade
                            </Typography>
                            <Typography variant='body2paralell' textAlign='center' width='66px' color='#8B8B8B'>
                                Temp
                            </Typography>
                            <Typography variant='body2paralell' textAlign='center' width='76px' color='#8B8B8B'>
                                Time
                            </Typography>
                        </Box>
                        <Box sx={{ p: 1 }} onClick={() => setExpanded(!expanded)}>
                            <UpArrow />
                        </Box>
                    </Box>
                    {settings.map((setting, index) => {
                        const TatFlag = index === firstTATIndex;
                        return (
                            <Settings key={index} setting={setting} TATFlag={TatFlag} />
                        );
                    })}
                    {/* {settings.length > 1 && <Box sx={{ border: '1px solid #CBCBCB', mx: 4, position: 'sticky', bottom: 103 }} />} */}
                </Box>
            </Box >
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', mt: 1 }}>
                <Box sx={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                    <ClockIcon />
                    <Typography variant="ingredientText2mini">Total time</Typography>
                </Box>
                <Typography variant="timeTextSettings">{!!containsTATInstruction && "≈ "}{getTime(totalTime)}</Typography>
            </Box>
        </Box>
    );
};

export default SettingsDisplay